<template>
  <div class="mt-6 flex flex-col items-center justify-center gap-y-6 py-12">
    <img :src="stateProperties.image" width="140" height="104" :alt="stateProperties.alt" />
    <div class="gap-y-6">
      <gv-type breakpoint="none" uplifted-variant="subtitle-sm" class="text-center">{{ stateProperties.title }}</gv-type>
      <gv-type breakpoint="none" uplifted-variant="body-1" class="w-[400px] max-w-[50vw] text-center text-type-secondary sm:max-w-[90vw]">{{
        stateProperties.description
      }}</gv-type>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import HazardBuilding from '@/common/assets/images/hazard-building.svg?url';
import HazardNotFound from '@/common/assets/images/hazard-not-found.svg?url';
import { EmptyStateType } from '.';

const props = withDefaults(defineProps<{ state?: EmptyStateType }>(), {
  state: EmptyStateType.HazardNotFound,
});

const stateProperties = computed(() => {
  let properties = {
    title: 'Expired',
    description:
      'This warning is no longer current. It may have been updated or expired. Please refresh your browser to see the latest information.',
    image: HazardNotFound,
    alt: 'Hazard expired',
  };

  if (props.state === EmptyStateType.HazardBuilding) {
    properties = {
      title: 'Publishing',
      description: 'This warning is uploading and will be available soon. Please refresh your browser to see the latest information.',
      image: HazardBuilding,
      alt: 'Publishing hazard',
    };
  }

  return properties;
});
</script>
